import { enqueueSnackbar } from "notistack";
import { useListMap } from "../../../hooks/map";
import { useRobots } from "../../../hooks/robot";
import AssignRobotMapToRobotScreen from "../quick-setup/assign-robot-map-to-robot";
import { Typography } from "@mui/material";
import { RobotType } from "../../../hooks/config-page/robot.type";

export default function AssignRobotPage() {
  const onSubmit = () => {
    // Handle submit logic here
    enqueueSnackbar({
      message: (
        <Typography>
          Data saved successfully
        </Typography>
      ),
      variant: 'success',
      autoHideDuration: 2000,
    })
  }

  return (
    <>
      <AssignRobotMapToRobotScreen
        onSubmit={() => onSubmit()}
        nextLabel=""
      />
    </>
  )
}